import api from './api'

/** Redes atrás do peer (LAN remota), tabela remote_networks. */
export const remoteNetworksApi = {
  getByRouter: async (routerId) => {
    const response = await api.get(`/routers/${routerId}/remote-networks`)
    return response.data
  },

  getByHost: async (hostId) => {
    const response = await api.get(`/hosts/${hostId}/remote-networks`)
    return response.data
  },

  create: async (deviceType, deviceId, data) => {
    const prefix = deviceType === 'host' ? 'hosts' : 'routers'
    const response = await api.post(`/${prefix}/${deviceId}/remote-networks`, data)
    return response.data
  },

  update: async (deviceType, deviceId, id, data) => {
    const prefix = deviceType === 'host' ? 'hosts' : 'routers'
    const response = await api.put(`/${prefix}/${deviceId}/remote-networks/${id}`, data)
    return response.data
  },

  delete: async (deviceType, deviceId, id) => {
    const prefix = deviceType === 'host' ? 'hosts' : 'routers'
    await api.delete(`/${prefix}/${deviceId}/remote-networks/${id}`)
  },
}
